<template>
  <v-app id="managepdf">
    <div
      v-if="$route.query.ec_content_type == 'mobiledigital'"
      style="text-align: center; background: #474642; width: 100%; height: 100%"
    >
      <img
        :src="imagelist[0].downlaod_url"
        style="position: relative; top: 50%"
      />
    </div>
    <div v-else style="margin: 20px; background: #e8e8ff; text-align: center">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="dots"
        color="#007bff"
        :height="45"
        :width="75"
        :is-full-page="fullPage"
      ></loading>

      <div>
        <div
          v-if="imagelist.length > 0"
          style="font-size: 12px; padding-top: 5px"
        >
          <a href="#" onClick="javascript:window.close('','_parent','');">
            <v-btn class="mx-2" small color="primary" @click="search">
              <strong>Close</strong>
            </v-btn></a
          >
        </div>
        <span v-if="imagelist.length > 0" style="font-size: 12px"
          >Click <a @click="open_uploaded_pdf" target="__blank">here</a> to Open
          PDF file</span
        >
        <div
          v-if="imagelist.length > 0"
          style="font-weight: bold; font-size: 12px"
        >
          Click on an image to set default Product preview:
        </div>
        <div v-for="item in imagelist" :key="item.productID">
          <div v-if="item.img_document_default == 1" style="position: relative">
            <img
              @click="
                setDefaultProductImage(item.productID, item.img_document_sort)
              "
              style="
                marging: 5px;
                padding: 8px;
                border: 4px solid #009933;
                cursor: pointer;
              "
              :src="item.downlaod_url"
            />
          </div>
          <div v-else>
            <img
              @click="
                setDefaultProductImage(item.productID, item.img_document_sort)
              "
              style="marging: 5px; padding: 8px; cursor: pointer"
              :src="item.downlaod_url"
            />
          </div>

          <div style="" v-if="item.img_document_default == 1">
            <span
              v-on:click="rotateImage(item.productID, item.img_document_sort)"
              style="cursor: pointer; font-size: 13px; color: #1976d2"
              >Rotate 90°</span
            >
            <!-- <v-icon  id="icon_style" v-on:click="rotateImage(item.productID,item.img_document_sort)"  data-inline="true" title="Rotate by 90">mdi-rotate-right</v-icon> -->
          </div>
        </div>
        <div
          v-if="imagelist.length > 0"
          style="font-size: 12px; padding-top: 5px"
        >
          <a href="#" onClick="javascript:window.close('','_parent','');">
            <v-btn class="mx-2" small color="primary" @click="search">
              <strong>Close</strong>
            </v-btn></a
          >
        </div>
             <span  v-if="imagelist.length <50" style="font-size:12px;color:blue;cursor:pointer" @click="orignal_images">Original Images | </span> <span v-if="imagelist.length <50" style="font-size:12px;color:blue;cursor:pointer" @click="resample3">Resample Try #3</span>
      </div>

    </div>
    
  </v-app>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
  name: "ManagePdf",
  components: {
    Loading,
  },
  data: () => ({
    isLoading: false,
    imagelist: [],
    defaultcolor: "border:4px solid green",
    rotatingmessage: "",
    redirect_url: "",
    product_type: "ProductImg",
  }),
  mounted() {
    var view = this;
    if (this.$route.query.product_type !== undefined)
      this.product_type = this.$route.query.product_type;
    view.view_images(view.$route.params.product_id);
    view.redirect_url = view.$url("TEMP_PRODUCT_LISTING");
  },
  methods: {
    /**
     * @desc:endpoint for returning images of pdf page by page
     * @return array
     */
    orignal_images:function(){
       var view = this
       view.isLoading = true;
       var endPoint =
        view.$url("RESAMPLE3")+"/"+view.$route.params.product_id+"?imagetype=orginal";
       view
        .$fetch(
          {
            url: endPoint,
            type: "GET",
            contentType: "application/json",
          },
          {
            operation: "add",
            vueScope: view,
          }
        )
        .then(function (r) {
          console.log(r);
          view.isLoading = false;
          view.view_images(view.$route.params.product_id)
        })
        .catch(function (e) {
          console.log(e)
          view.isLoading = false;
          view.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title: "some error occured",
          });
        });

     },
     resample3:function(){
       var view = this
       view.isLoading = true;
       var endPoint =
        view.$url("RESAMPLE3")+"/"+view.$route.params.product_id;
       view
        .$fetch(
          {
            url: endPoint,
            type: "GET",
            contentType: "application/json",
          },
          {
            operation: "add",
            vueScope: view,
          }
        )
        .then(function (r) {
          console.log(r);
          
          view.view_images(view.$route.params.product_id)
        })
        .catch(function (e) {
          console.log(e)
          view.isLoading = false;
          view.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title: "some error occured",
          });
        });

     },
    view_images: function (product_id) {
      var view = this;
      view.isLoading = true;
      var endPoint =
        view.$url("VIEW_PDF_IMAGES") +
        "?product_id=" +
        product_id +
        "&product_type=" +
        this.product_type +
        "&show=all";
      view
        .$fetch(
          {
            url: endPoint,
            type: "GET",
            contentType: "application/json",
          },
          {
            operation: "add",
            vueScope: view,
          }
        )
        .then(function (r) {
          console.log(r);
          view.isLoading = false;
          view.imagelist = r.payload;
        })
        .catch(function (e) {
          view.isLoading = false;
          view.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title: e.responseJSON.payload.msg,
          });
        });
    },
    /**
     *
     */
    rotateImage: function (product_id, image_sort) {
      var view = this;
      view.isLoading = true;
      var endPoint =
        view.$url("ROTATE_IMAGES") +
        "?product_id=" +
        product_id +
        "&document_sort=" +
        image_sort;
      view
        .$fetch(
          {
            url: endPoint,
            type: "GET",
            contentType: "application/json",
          },
          {
            operation: "add",
            vueScope: view,
          }
        )
        .then(function (r) {
          console.log(r);
          view.view_images(product_id);
          view.isLoading = false;
        })
        .catch(function (e) {
          console.log(e);
          view.isLoading = false;
          view.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title: "Product Image not created",
          });
        });
    },
    /**
     *
     */
    setDefaultProductImage: function (product_id, image_sort) {
      var view = this;
      view.isLoading = true;
      let token = view.$utils.getAccessToken();
      let formData = new FormData();
      formData.append("product_id", product_id);
      var endPoint =
        view.$url("ROTATE_IMAGES") +
        "?product_id=" +
        product_id +
        "&document_sort=" +
        image_sort;
      axios
        .post(endPoint, formData, {
          headers: {
            Authorization: token,
            "Content-Type": "multipart/form-data",
            userid: view.$utils.getCookies("user_id"),
          },
        })
        .then(function () {
          view.view_images(product_id);
          view.isLoading = false;
          view.rotatingmessage = "";
          //window.open(view.redirect_url, '_blank');
        });
    },
    /**
     *
     */
    open_uploaded_pdf() {
      var view = this;
      let product_id = view.$route.params.product_id;
      window.open(
        view.$url("DIRECT_MAIL_PDF_URL") +
          "?product_id=" +
          product_id +
          "&isproduct_pdf=1",
        "_blank"
      );
    },
  },
};
</script>

<style lang='sass' scoped>
@import './../assets/sass/company'
</style>